import { Review } from '@components/Reviews/types';
import { imagePicker } from '@utils/imagePicker';
import React from 'react';

const useReviewsQuery = (directus: any): Review[] => {
	const reviews = React.useMemo(
		() =>
			directus.PageReviews[0].Reviews.map((review) => ({
				...review.Reviews_id,
				logo: imagePicker(review.Reviews_id.logo),
			})),
		[directus]
	);
	return reviews;
};

export default useReviewsQuery;
